// extracted by mini-css-extract-plugin
module.exports = {"bubble":"LzBwo","content":"_2s2eG","triangleWrapper":"_2U4DC","arrowleft":"_1JbVD","triangle":"Pz0NF"};